import { Box, styled } from "@mui/material";
import { useData } from "../../../utils/useData";
import { CheckoutBase } from "../CheckoutBase";
import { AccountAssignmentBaseCheckoutProps } from "../Standard/AccountAssignmentBaseCheckoutProps";
import {
  FundingRequirement,
  LineItem,
  StandardLineitems
} from "../Standard/StandardLineitems";
import { CoverageRequirementTooltip } from "../Standard/Tooltips/CoverageRequirementTooltip";
import { LoadFeeTooltip } from "../Standard/Tooltips/LoadFeeTooltip";
import { PublicTransportCheckoutProductDetails } from "./PublicTransportCheckoutProductDetails";

const PublicTransportCheckoutContainer = styled(Box)(() => ({
  padding: "12px 8% 12px 8%",
  height: "100%"
}));

export const PublicTransportCheckout = (
  accountAssignmentCheckoutProps: AccountAssignmentBaseCheckoutProps
) => {
  const { plans, employerModules, employerFund } = useData();

  const { selectedPlan, selectedEmployees, onConfirm } =
    accountAssignmentCheckoutProps;

  const selectedPlanModuleType =
    selectedPlan.employerModuleOptions.employerModuleType;
  const selectedPlanModule = employerModules?.data?.find(
    (x) => x.employerModuleType === selectedPlanModuleType
  );
  const fundingRequirementPercent =
    selectedPlan.employerModuleOptions.fundCoverageRequirementPercent ??
    selectedPlanModule?.employerModuleConfig.fundCoverageRequirementPercent ??
    0;

  const moduleMonthlyUserFee =
    selectedPlanModule?.employerModuleConfig.monthlyUserFee ?? 0;

  const loadFeePercent =
    selectedPlan.employerModuleOptions.loadFeePercent ??
    selectedPlanModule?.employerModuleConfig.loadFeePercent ??
    0;

  const availableFunds = employerFund.data?.availableBalance.amount ?? 0;

  const selectedPlanDetails = plans?.data?.items.find(
    (x) => x.id === selectedPlan.planId
  );

  const selectedTier = selectedPlanDetails?.tiers.find(
    (x) => x.id === selectedPlan.tierId
  );

  const totalAssignment =
    (selectedTier?.amount.amount ?? 0) * selectedEmployees.length;

  const loadFee = totalAssignment * loadFeePercent;
  const fundingRequirementAmount = totalAssignment * fundingRequirementPercent;
  const totalRequirement = fundingRequirementAmount + loadFee;

  const lineItems: LineItem[] = [
    {
      name: `${selectedPlanDetails?.name ?? ""} - ${selectedTier?.name ?? ""}`,
      price: selectedTier?.amount.amount ?? 0,
      quantityName: "Number of users",
      quantity: selectedEmployees.length
    },
    {
      name: "Total being assigned",
      price: totalAssignment
    },
    {
      name: `Load fee (${(loadFeePercent * 100).toFixed(2)}%)`,
      price: loadFee,
      lineItemTooltip: <LoadFeeTooltip />,
      indented: true
    }
  ];

  const fundingRequirement: FundingRequirement = {
    name: `Coverage Requirement (${(fundingRequirementPercent * 100).toFixed(
      2
    )}%)`,
    price: fundingRequirementAmount,
    fundingRequirementTooltip: <CoverageRequirementTooltip />,
    indented: true
  };

  return (
    <PublicTransportCheckoutContainer>
      <CheckoutBase
        title="Public Transport - Confirmation"
        onConfirm={onConfirm}
        hasInsufficientCoverageFunds={availableFunds < totalRequirement}
      >
        <PublicTransportCheckoutProductDetails monthlyUserFee={moduleMonthlyUserFee} />
        <StandardLineitems
          lineItems={lineItems}
          fundingRequirement={fundingRequirement}
          total={totalRequirement}
          amountDue={loadFee}
        />
      </CheckoutBase>
    </PublicTransportCheckoutContainer>
  );
};
